import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Subscription } from 'rxjs';

import { CdsButtonConfig } from '@cds/ng-core/button';
import { MatDialogRef } from '@cds/ng-web-components/popup';

import { LanguageChangeService } from 'src/app/shared/language-change.service';
import { CdsButtonModule } from '@cds/ng-web-components/button';
import { CdsLanguageModule } from '@cds/ng-core/lang';

@Component({
  selector: 'app-user-success-submitted',
  templateUrl: './user-success-submitted.component.html',
  styleUrls: ['./user-success-submitted.component.scss'],
  imports: [CdsButtonModule, CdsLanguageModule],
})
export class UserSuccessSubmittedComponent implements OnInit, OnDestroy {
  private dialogRef = inject<MatDialogRef<UserSuccessSubmittedComponent>>(MatDialogRef);
  private languageChangeService = inject(LanguageChangeService);

  language = 'EN';
  lanSubscription?: Subscription;
  agreeButtonConfig: CdsButtonConfig = {
    size: 'sm',
    style: 'primary',
    disabled: false,
  };

  ngOnInit(): void {
    this.lanSubscription = this.languageChangeService.lanSubject.subscribe(lan => {
      this.language = lan === 'en' ? 'EN' : 'TC';
    });
  }

  ngOnDestroy(): void {
    this.lanSubscription?.unsubscribe();
  }

  agree() {
    this.dialogRef.close({ agree: true });
  }
}
